import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import Buttons from './Buttons';
import CircleButtonWithArrow from '../CircleButtonWithArrow';

class Slider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            coord: null,
        };

        this.onUp = this.onUp.bind(this);
        this.onPress = this.onPress.bind(this);
        this.changeIndex = this.changeIndex.bind(this);
        this.setWindowIndexImage = this.setWindowIndexImage.bind(this);
        this.callbackCloseFullSize = this.callbackCloseFullSize.bind(this);
    }

    onPress(pressCoord) {
        this.setState({
            coord: pressCoord,
        });
    }

    onUp(upCoord) {
        const { currentIndex, coord } = this.state;
        const { slides } = this.props;
        const maxIndex = slides.length - 1;
        let newIndex = currentIndex;
        if (upCoord > coord + 20) {
            newIndex = currentIndex - 1;
        } else if (upCoord < coord - 20) {
            newIndex = currentIndex + 1;
        }
        if (newIndex > maxIndex) {
            newIndex = 0;
        } else if (newIndex < 0) {
            newIndex = maxIndex;
        }
        this.changeIndex(newIndex);
    }

    setWindowIndexImage() {
        const { currentIndex } = this.state;
        const { uuid } = this.props;
        window[`slider-${uuid}-value`] = currentIndex;
    }

    changeIndex(index) {
        const { slides } = this.props;
        let newIndex = null;
        if (index > slides.length - 1) {
            newIndex = 0;
        } else if (index < 0) {
            newIndex = slides.length - 1;
        } else {
            newIndex = index;
        }
        this.setState({
            currentIndex: newIndex,
        }, this.setWindowIndexImage);
    }

    callbackCloseFullSize() {
        const { uuid } = this.props;
        const { slides } = this.props;
        const newIndex = window[`slider-${uuid}-value`];
        if (newIndex >= 0 && newIndex <= slides.length - 1) {
            this.setState({
                currentIndex: newIndex,
            });
        }
    }

    render() {
        const { currentIndex } = this.state;
        const {
            className,
            slides,
            handleOpen,
            uuid,
        } = this.props;
        return (
            <Root
                className={className}
                isShowRightButton={currentIndex < slides.length - 1}
                isShowLeftButton={currentIndex > 0}
            >
                <>
                    {slides.map((slide, index) => (
                        <Slide
                            key={index.toString()}
                            style={{ display: currentIndex === index ? 'block' : 'none' }}
                            src={slide}
                            onClick={() => handleOpen(
                                slides,
                                uuid,
                                this.callbackCloseFullSize,
                                currentIndex,
                            )}
                            onMouseDown={(e) => this.onPress(e.clientX)}
                            onMouseUp={(e) => this.onUp(e.clientX)}
                            onTouchStart={(e) => this.onPress(e.changedTouches[0].pageX)}
                            onTouchEnd={(e) => this.onUp(e.changedTouches[0].pageX)}
                        />
                    ))}
                </>
                <StyledButtons
                    quantity={slides.length}
                    currentIndex={currentIndex}
                    onClick={this.changeIndex}
                />
                <ArrowButtonRight
                    isArrowRight
                    onClick={() => this.changeIndex(currentIndex + 1)}
                />
                <ArrowButtonLeft onClick={() => this.changeIndex(currentIndex - 1)} />
            </Root>
        );
    }
}

const StyledButtons = styled(Buttons)`
    display: ${({ quantity }) => (quantity === 1 ? 'none' : '')};
    position: absolute;
    bottom: 0px;
    left: auto;
`;

const ArrowButtonRight = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    right: 16px;
    opacity: 0;
`;

const ArrowButtonLeft = styled(CircleButtonWithArrow)`
    position: absolute;
    top: calc(50% - 16px);
    left: 16px;
    opacity: 0;
`;

const Slide = styled.img`
    width: 100%;
    height: 241px;
    cursor: pointer;

    ${mediaWidth.m} {
        height: 234px;
    };

    ${mediaWidth.l} {
        height: 207px;
    };

    ${mediaWidth.xl} {
        height: 297px;
    };
`;

const Root = styled.div`
    position: relative;
    display: flex;
    justify-content: center;

    ${ArrowButtonRight} { display: none; }
    ${ArrowButtonLeft} { display: none; }

    ${mediaWidth.l} {
        ${ArrowButtonRight} { display: ${({ isShowRightButton }) => (isShowRightButton ? 'block' : 'none')}; }
        ${ArrowButtonLeft} { display: ${({ isShowLeftButton }) => (isShowLeftButton ? 'block' : 'none')}; }

        :hover {
            ${ArrowButtonRight} { opacity: 1; }
            ${ArrowButtonLeft} { opacity: 1; }
        }
    }
`;

export default Slider;
